/**
 * Shared gender options for profile and guest booking forms.
 */

export const GENDER_OPTIONS = ['Male', 'Female', 'Other'] as const;

export type GenderOption = (typeof GENDER_OPTIONS)[number];

const GENDER_ALIASES: Record<string, GenderOption> = {
  male: 'Male',
  m: 'Male',
  female: 'Female',
  f: 'Female',
  other: 'Other',
  'non-binary': 'Other',
  nonbinary: 'Other',
};

export const normalizeGender = (gender: string | null | undefined): string => {
  if (!gender) {
    return '';
  }
  const trimmed = gender.trim();
  if ((GENDER_OPTIONS as readonly string[]).includes(trimmed)) {
    return trimmed;
  }
  return GENDER_ALIASES[trimmed.toLowerCase()] ?? trimmed;
};
